import SvgColor from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const navConfig = [
  {
    title: 'Pickems',
    path: '/dashboard/pickems',
    icon: icon('ic_analytics'),
  },
  {
    title: 'Leaderboards',
    path: '/dashboard/leaderboards',
    icon: icon('ic_analytics'),
  },
  {
    title: 'Pages',
    path: '/dashboard/pages',
    icon: icon('file-text-outline'),
  },
  {
    title: 'Custom Leagues',
    path: '/dashboard/leagues',
    icon: icon('shield-outline'),
  },
  {
    title: 'Friends Leagues',
    path: '/dashboard/friends-leagues',
    icon: icon('people-outline'),
  },
  {
    title: 'Image Library',
    path: '/dashboard/image-library',
    icon: icon('image-outline'),
  },
  {
    title: 'Banners',
    path: '/dashboard/banners',
    icon: icon('image-outline'),
  },
];

export default navConfig;
